<!--
 * @Author: LHB
 * @Date: 2022-06-08 22:04:13
 * @LastEditTime: 2022-07-23 09:58:22
 * @LastEditors: LHB
 * @Description: 
 * @FilePath: \shirleyClass\src\modules\bindWx\index.vue
 * ---
-->

<template>
  <div class="wrap">
    <!-- 更换微信-start -->
    <div class="wrap-channge">
      <!-- 第一步-start -->
      <div class="content" v-if="bindStep == 1">
        <div class="box-input box-phone">
          <div>
            <p class="login-title">HI,{{ newNickname }}</p>

            <div class="info-box">
              <!-- 老微信头像 -->
              <img class="avatar" :src="oldUser.avatar" alt="" />
              <span class="name">{{ oldUser.nickname }}</span>
            </div>

            <div class="change-tips">
              将课程权益转移给你，绑定微信后立即生效！
            </div>
          </div>
        </div>
        <div class="btn-box">
          <van-button
            class="loginBtn change-btn"
            :disabled="isDisabled"
            @click="bindWx"
            >立即绑定</van-button
          >
        </div>
      </div>
      <!-- 第一步-end -->
      <!-- 第二步-start -->
      <div class="content content2" v-else-if="bindStep == 2">
        <div v-if="bindSuccess" class="bind-ok">
          <p class="login-title">HI,新微信名称</p>
          <div class="top">
            <img
              class="icon-success"
              src="../../assets/images/success.png"
              alt=""
            />
            <div class="title1">
              课程转移成功！<br />
              快去学习吧！
            </div>
          </div>
          <div class="btn-box">
            <div class="loginBtn change-btn" @click="bindGoClass">查看课程</div>
          </div>
        </div>
        <div v-else class="bind-error">
          <div class="top">
            <img
              class="icon-success"
              src="../../assets/images/non_icon.png"
              alt=""
            />
            <div class="title1">
              很抱歉，您的微信已经绑定其他课程
              <br />您的好友无法将课程转移给你哦。
            </div>
          </div>
          <div class="btn-box">
            <van-button class="loginBtn change-btn" @click="contact"
              >如需帮助 联系客服</van-button
            >
          </div>
        </div>
      </div>
      <!-- 第二步-end -->
    </div>
    <!-- 更换微信-end -->
  </div>
</template>
<script>
import group from '../common/group'
import utils from '../../utils/index.js'
import tools from '../common/tools.js'
import wx_tools from '../common/wx_tools.js'
import urls from '../../utils/urls'

export default {
  name: 'changewx',
  components: {},
  data() {
    return {
      oldUser: '',
      token: '',
      tokenKey: 'tokenKey',
      phone: '',
      phoneKey: 'phoneKey',
      bindStep: 1,
      newNickname: '',
      newNicknameKey: 'newNicknameKey',
      bindSuccess: false,
      // 微信授权的thirdId
      wxBindThirdid: '',
      wxBindThirdidKey: 'wxBindThirdidKey',
      bindcode: '',
      cThirdId: '',
      bindcodeKey: 'bindcodeKey',
      isDisabled: false,
      isCanBind: false,
      orginBindUrlKey: 'orginBindUrlKey',
      mainKeFuUrl:
        'https://work.weixin.qq.com/kfid/kfc7d5301c836e053ab?enc_scene=ENC3QTNZ7Rwc9EQ8M5WrnVEQqEKTCwzPjr5UJoegdoirVD3oEZqobbRv4h4uQM6aFF8aV'
    }
  },
  mounted() {
    document.title = '雪梨英语'
    if (window.location.href.includes('#/')) {
      this.bindcode =
        tools.getHashQueryString('bindcode') ||
        localStorage.getItem(this.bindcodeKey)
    } else {
      this.bindcode =
        tools.getQueryString('bindcode') ||
        localStorage.getItem(this.bindcodeKey)
    }
    this.phone = localStorage.getItem(this.phoneKey)
    this.wxBindThirdid = localStorage.getItem(this.wxBindThirdidKey)
    this.newNickname = localStorage.getItem(this.newNicknameKey)
    localStorage.setItem(this.bindcodeKey, this.bindcode)
    console.log(
      'bind1',
      this.bindcode,
      this.phone,
      this.wxBindThirdid,
      this.newNickname
    )

    // if (window.location.href.indexOf('code') != -1) {
    //   let
    // }

    // this.bindStep = 2
    // this.bindSuccess = false
    // return

    if (this.bindcode) {
      // 查询是否过期或者已绑定
      this.checkLink()
    }

    this.initShare()
  },
  watch: {},
  methods: {
    checkLink() {
      const params = { id: this.bindcode }
      group.checkBind
        .call(this, params)
        .then((res) => {
          console.log('checkBind', res)
          if (res.data.success) {
            this.oldUser = res.data.data
            this.authGetPhone()
          } else {
            this.isDisabled = true
            this.$toast(res.data.error.msg)
            this.$router.replace({
              name: 'bindLinkerror'
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    // 更换微信绑定
    bindWx() {
      console.log('更换微信绑定')
      if (this.isCanBind) {
        utils.tools.showLoading('正在绑定...')
        // 调用绑定了逻辑
        console.log('调用绑定了逻辑')
        const params = { applyId: this.bindcode, thirdId: this.wxBindThirdid }
        group.execute
          .call(this, params)
          .then((res) => {
            utils.tools.hideLoading()
            console.log('更换微信重新绑定结果====', res)
            if (res.data.success) {
              //更换成功，需要保存用户信息，跳转到首页
              localStorage.setItem(this.tokenKey, res.data.data.token.token)
              this.$toast('更换成功')
              // 把bindcode
              localStorage.setItem(this.bindcodeKey, '')
              setTimeout(() => {
                this.$router.replace({
                  name: 'home'
                })
              }, 500)
            } else {
              // 不要toast
              // this.$toast(res.data.error.msg)
              // let timer = setTimeout(() => {
              //   clearTimeout(timer)
              this.bindStep = 2
              // }, 1000)
            }
          })
          .catch((error) => {
            utils.tools.hideLoading()

            console.log(error)
          })
      }
    },
    /**
     * 更换完微信，去课程首页
     */
    bindGoClass() {},
    // 联系客服
    contact() {
      console.log('联系客服')
      window.location.href = this.mainKeFuUrl
    },
    authGetPhone() {
      if (!this.wxBindThirdid) {
        let code =
          tools.getQueryString('code') || tools.getHashQueryString('code') || ''
        console.log('code----', this.code)
        if (code) {
          this.wxLogin(code)
        } else {
          localStorage.setItem(this.orginBindUrlKey, window.location.href)
          console.log('授权之前的hrfe', localStorage.getItem('orginBindUrlKey'))
          this.strongAuth()
        }
      } else {
        // this.getInviteHistory()
        console.log('已经有wxThirdId了', this.wxBindThirdid, this.phone)
        // 可以绑定
        this.isCanBind = true
      }
    },
    /**
     * @description: 显示授权
     * @param {*}
     * @return {*}
     *
     */
    strongAuth() {
      console.log('window.location.href', window.location.href)
      let params = { redirect_uri: window.location.href }
      wx_tools.strongAuth(params)
    },

    wxLogin(code) {
      // 重新调转到处理掉code新链接
      group.wxLogin.call(this, utils.config.config.appId, code).then((res) => {
        console.log('微信登录信息-login', JSON.stringify(res))
        if (res.data.success) {
          if (res.data.data.token) {
            localStorage.setItem(this.tokenKey, res.data.data.token.token)
          }
          localStorage.setItem(this.phoneKey, res.data.data.user.mobile)
          localStorage.setItem(
            this.wxBindThirdidKey,
            res.data.data.user.thirdId
          )
          localStorage.setItem(this.newNicknameKey, res.data.data.user.nickname)
          console.log('bind-wxthirdid', res.data.data.user.thirdId)

          setTimeout(() => {
            window.location.replace(localStorage.getItem(this.orginBindUrlKey))
          })
        } else {
          if (
            res.data.error.code == 100000 ||
            res.data.error.msg.includes('授权失败')
          )
            console.log('code已使用，重新授权')
          this.strongAuth()
        }
      })
    },

    initShare() {
      console.log('调用initShare')
      const tempJumpLink = utils.config.config.shareUrl
      // 分享字数规则：主标题两行，副标题3行，超出全部...
      let shareObj = {
        debug: false,
        referer: tempJumpLink,
        appId: utils.config.config.appId,
        title: utils.config.config.shareMainTitle,
        desc: utils.config.config.shareDesTitle,
        link: tempJumpLink,
        imgUrl: utils.config.config.shareImgUrl,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
        // success: this.shareSuccess
        // fail: this.shareFail
      }
      console.log('分享跳转地址--login', shareObj)
      wx_tools.initShare.call(this, shareObj)
    }
  }
}
</script>

<style src="./index.css" scoped></style>
<style scoped></style>
